import React from 'react';
import Icon from '../../../components/AppIcon';

const redFlags = [
  { title: 'No Building Inspection Available', description: 'Vendor has not provided a building inspection report. Always obtain an independent inspection before making an offer.', action: 'Request inspection report from agent' },
  { title: 'Extended Days on Market', description: 'Property has been listed for 47 days vs suburb average of 32 days. This may indicate overpricing, undisclosed issues, or buyer hesitation.', action: 'Investigate reason for extended listing period' },
  { title: 'Busy Road Location', description: 'Property fronts an arterial road. This can impact liveability, noise levels, and future resale value. Inspect at peak traffic times.', action: 'Visit property during morning/evening peak hours' },
  { title: 'Older Electrical Wiring', description: 'Property built pre-2000 may have outdated electrical systems. Rewiring costs can range from $8,000 to $25,000 depending on property size.', action: 'Include electrical inspection in building report' },
];

const RedFlagDetector = () => (
  <div className="bg-card rounded-xl border border-red-500/30 p-6" style={{ background: 'rgba(255,68,68,0.03)' }}>
    <div className="flex items-center gap-3 mb-4">
      <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{ background: 'rgba(255,68,68,0.15)' }}>
        <Icon name="AlertOctagon" size={18} color="#FF4444" />
      </div>
      <h3 className="text-lg font-semibold text-foreground">Red Flag Detector</h3>
      <span className="px-2 py-0.5 rounded-full text-xs font-medium" style={{ background: 'rgba(255,68,68,0.15)', color: '#FF6666' }}>{redFlags?.length} detected</span>
    </div>
    <div className="space-y-3">
      {redFlags?.map((flag, i) => (
        <div key={i} className="p-4 rounded-lg border border-red-500/20 bg-red-500/5">
          <div className="flex items-start gap-3">
            <Icon name="Flag" size={16} color="#FF4444" />
            <div>
              <p className="font-medium text-foreground mb-1">{flag?.title}</p>
              <p className="text-sm text-muted-foreground mb-2">{flag?.description}</p>
              <div className="flex items-center gap-2">
                <Icon name="ArrowRight" size={14} color="#00D4FF" />
                <p className="text-xs font-medium" style={{ color: '#00D4FF' }}>{flag?.action}</p>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default RedFlagDetector;
